import FormView from './src/formView.vue';

/* istanbul ignore next */
FormView.install = function(Vue) {
    Vue.component(FormView.name, FormView);
};

export default FormView;